import { Routes, Route, useLocation, Navigate, BrowserRouter } from "react-router-dom";
import React, {  useEffect } from "react";
import HomeLandingPage from "./components/HomePage";
import ShopPage from "./components/Shop/shop";
import Header from "./components/Header/Header";
import ProductPage from "./components/ProductPage/ProductPage";
import CartPage from "./components/CartPage/CartPage";
import Footer from "./components/Footer/Footer";
import CheckoutPage from "./components/CheckoutPage/CheckoutPage";
import LoginPage from "./components/LoginPage/LoginPage";
import AboutUs from "./components/AboutPage/AboutPage";
import ContactUs from "./components/ContactPage/ContactPage";
import { ResetPasswordPage } from "./components/ResetPasswordPage/ResetPasswordPage";
import WishlistPage from "./components/WishlistPage/WishlistPage";
import OrderHistoryPage from "./components/OrderHistoryPage/OrderHistoryPage";
import Chatbot from "./components/ChatBotPopup/ChatBotPopup";
import PaymentFailedPage from "./components/PaymentFailedPage/PaymentFailedPage";
import ThankYouPage from "./components/ThankYouPage/ThankYouPage";
function Layout() {
  const location = useLocation();
  const hideHeaderFooter = 
  location.pathname === "/checkoutpage" ||
  location.pathname === "/paymentsuccess" ||
  location.pathname === "/paymentFail";

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on mount
  }, []);

  return (
    <>
      {!hideHeaderFooter && <Header />}
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} /> 
        <Route path="/home" element={<HomeLandingPage />} />
        <Route path="/ecommerce/reset-password/:token" element={<ResetPasswordPage />} />

        <Route path="/shop" element={<ShopPage />} />
        <Route path="/shop/:selectedProduct" element={<ShopPage />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/product/:id" element={<ProductPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/orderhistory" element={<OrderHistoryPage />} />
        <Route path="/checkoutpage" element={<CheckoutPage />} />
        <Route path="/paymentsuccess" element={<ThankYouPage />} />
        <Route path="/paymentFail" element={<PaymentFailedPage />} />






      </Routes>
      {!hideHeaderFooter && <Footer />}
      {!hideHeaderFooter && <Chatbot />}

    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<Layout />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
